import { RawUser, User } from '../types';

export const addDerivedUserData = (rawUserData: RawUser): User => ({
  ...rawUserData,
  full_name: `${rawUserData.first_name} ${rawUserData.last_name}`,
});
